import { render, staticRenderFns } from "./lomActionsCellRenderer.vue?vue&type=template&id=60124068"
import script from "./lomActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./lomActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports